import React, { useRef } from 'react';
import './index.less'

// 统一的导航配置 - 使用相对路径
const NAV_LIST = [
  {name: '企业介绍', path: './index.html'},
  {name: '招聘程序', path: './recruitment.html'},
  {name: '岗位投递', path: './jobs.html'},
  {name: '人才管理', path: './talent.html'},
  {name: '其他注意事项', path: './notice.html'}
];

/**
 * 导航组件
 * @param {Object} props
 * @param {number} props.active - 当前激活的导航项索引 (0-3)
 */
const Navigation = (props) => {
  const { active = 0 } = props;
  const submenuRef = useRef(null);
  
  const handleNavClick = (e, index, path) => {
    // 如果点击的是当前激活项，阻止跳转
    if (index === active) {
      e.preventDefault();
      return false;
    }
    
    // 其他项正常跳转
    if (path) {
      window.location.href = path;
    }
  };
  
  return (
    <div className="navbar">
      <div className="navbar-inner">
        <ul className="navbar-inner-list">
          {NAV_LIST.map((item, index) => {
            const isActive = active === index;
            return (
              <li 
                key={index} 
                className={`nav-li ${isActive ? "nav-active" : ""}`} 
                ref={submenuRef}
              >
                <a 
                  href={item.path}
                  onClick={(e) => handleNavClick(e, index, item.path)}
                  style={{ cursor: isActive ? 'default' : 'pointer' }}
                >
                  {item.name}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};



export default Navigation
